//framework boot up
require('./bootstrap');
require('./extend');
import Vue from 'vue';

//inertia
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
Vue.use(InertiaPlugin);

//portal
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

//vuetify
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
Vue.use(Vuetify);

//vuex
import store from './Store'
// Vue.mixin({ methods: { route } });

//pinia
import { createPinia, PiniaVuePlugin } from 'pinia';
Vue.use(PiniaVuePlugin);
const pinia = createPinia();

//i18n
import { i18n } from "@/i18n";

//create and mount vue app with all enabled plugins
const app = document.getElementById('app');

new Vue({
    //store,
    pinia,
    i18n,
    vuetify: new Vuetify(),
    render: (h) =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: (name) => require(`./Pages/${name}`).default,
            },
        }),
}).$mount(app);
